module.exports = __webpack_public_path__ + "9a0282196554f70a8af7116b58033d81.svg";